import React from 'react';
import loadable from '@loadable/component';

const LoadableComponent = loadable(() =>
  import(/* webpackChunkName: "graph" */ './price-history-curve')
);

const PriceHistoryCurveLoader = props => <LoadableComponent {...props} />;

export default PriceHistoryCurveLoader;
